import {makeBFFApiUrl} from 'main/factories/http';

import {RemotePostOurDoctorMessage} from 'data/usecases/private/home/post-our-doctor-message';
import {PostOurDoctorMessage} from 'domain/usecases/private/home/post-our-doctor-message';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {OurDoctorEndpoints} from 'main/factories/usecases/endpoints';

export const makePostOurDoctorMessage = (): PostOurDoctorMessage =>
	new RemotePostOurDoctorMessage(
		makeBFFApiUrl(OurDoctorEndpoints.ourDoctor),
		makeAuthorizeHttpClientDecorator(),
	);
